import { Radio, styled } from '@mui/material';

const StyledRadioButton = styled(Radio)({
  '&:hover': {
    backgroundColor: 'transparent'
  }
});

export default StyledRadioButton;
